import { useState, useEffect, useCallback } from "react";

const useZoomScale = () => {
  const [scale, setScale] = useState(1);

  const handleZoomScale = () => {
    setScale(window.visualViewport.scale);
  }

  useEffect(() => {
    window.visualViewport.addEventListener("resize", handleZoomScale);

    handleZoomScale();

    return () => window.visualViewport.removeEventListener("resize", handleZoomScale);
  }, [handleZoomScale]);

  return scale
};

export default useZoomScale;
